import styled from 'styled-components'

const IconButton = styled.div`
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  padding: 8px;
  position: relative;
  border-radius: 10px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  pointer-events: auto;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s ease-in-out;
  min-width: 38px;
  min-height: 38px;
  color: rgb(0, 0, 0);
  background: transparent;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: rgb(224, 224, 224);
  }
`

export default IconButton